module.exports = __webpack_public_path__ + "static/Kurgastehaus2-1781906c5a0a0c6b6ee94a4f42b19d95.png";